export default [
  '/images/hydroforming_photos/1.webP',
  '/images/hydroforming_photos/2.webP',
  '/images/hydroforming_photos/3.webP',
];
